import { useState } from "react";
import REGEX from "../Constants/Regex";


export function YoutubeGallery({ title, tagline, items = [], quality = "maxresdefault" }) {
    const [activeVideo, setActiveVideo] = useState(null);

    function getYouTubeVideoId(url) {
        const regex = REGEX.YOUTUBE_REGEX;
        const videoIdMatch = url.match(regex);
        const videoId = videoIdMatch ? videoIdMatch[1] : null;

        return videoId;
    }

    return (
        <div className='flex flex-col items-center'>
            <div className='w-full md:w-[60%] flex flex-col items-center gap-6 mb-10'>
                <h2
                    className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                    {title}
                </h2>
                <p className="text-sm text-center sm:text-base italic md:text-xl font-urbanist text-stone-300">
                    {tagline}
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-6xl mx-auto mb-12">

                {items.map((linkDetails, i) => {

                    const videoId = getYouTubeVideoId(linkDetails?.link);
                    const uniqueVideoId = `youtube_${i}_${videoId}`;

                    const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                    return (
                        <div
                            key={i}
                            className="bg-white p-2 rounded-md overflow-hidden font-urbanist shadow-md group"
                        >
                            <div
                                className="relative cursor-pointer"
                                onClick={() => setActiveVideo(uniqueVideoId === activeVideo ? null : uniqueVideoId)}
                            >
                                {activeVideo === uniqueVideoId ? (
                                    <iframe
                                        id={`youtube_${i}`}
                                        width="100%"
                                        // height="250"
                                        src={`https://www.youtube.com/embed/${videoId}`}
                                        title={linkDetails?.title}
                                        frameBorder="0"
                                        allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        className="rounded-md h-[200px]"
                                    />
                                ) : (
                                    <>
                                        <img
                                            src={thumbnail}
                                            alt={linkDetails?.title}
                                            className="w-full h-[200px] object-cover group-hover:brightness-75 transition"
                                        />
                                        <div className="absolute inset-0 flex justify-center items-center opacity-0 group-hover:opacity-100 transition">
                                            <svg
                                                className="w-12 h-12 text-white drop-shadow-lg"
                                                fill="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path d="M8 5v14l11-7z" />
                                            </svg>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="pt-2 px-2 text-left">
                                <h4 className="text-sm font-semibold line-clamp-2">{linkDetails?.title}</h4>
                                {/* <p className="text-xs text-gray-500">{linkDetails?.views}</p> */}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}